import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';

@Component({
  selector: 'app-money-back-guarantee-popup',
  standalone: true,
  imports: [CommonModule, SvgIconComponent],
  templateUrl: './money-back-guarantee-popup.component.html',
  styleUrl: './money-back-guarantee-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoneyBackGuaranteePopupComponent {
  @Input() title: string;
  @Input() subtitle?: string;
  @Input() contentTitle?: string;
  @Input() description?: string;
  @Input() note?: string;
  @Input() withReverseText?: boolean;

  showContent = false;

  openContent(): void {
    this.showContent = true;
  }

  closeContent(): void {
    this.showContent = false;
  }

  toggleContentShow(): void {
    this.showContent = !this.showContent;
  }
}
